import { render } from "./siteNavigation.vue?vue&type=template&id=1a8a7d9a&scoped=true"
import script from "./siteNavigation.vue?vue&type=script&lang=js"
export * from "./siteNavigation.vue?vue&type=script&lang=js"

import "./siteNavigation.vue?vue&type=style&index=0&id=1a8a7d9a&scoped=true&lang=css"

import exportComponent from "/var/www/boca/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8a7d9a"]])

export default __exports__